<template>
  <CCard>
    <CCardHeader>
      <strong>Block User</strong>
    </CCardHeader>
    <CCardBody>
      <form @submit="onSubmit" enctype="multipart/form-data">


            <CRow>
              <CCol sm="12">
                <textarea class="text-field" v-model="block_users" style="height: 400px"></textarea>
              </CCol>
            </CRow>



          <button class="btn btn-lg btn-success" slot="finish" type="submit">Block User</button>

      </form>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "BlockUser",
  data() {
    return {
      languages: [{ value: 'en', label: 'English'}],
      topics: [{ value: 'all', label: 'Any Topic'}],
      partners: [{ value: null, label: 'Select a Partner'}],
      block_users: "",

      root_url: ROOT_URL,

    };
  },
  created() {

  },
  methods: {
    getLanguages(){
      this.$axios
          .get(`${ADMIN_URL}/languages`)
          .then((response) => {
            console.log(response.data.languages)
            this.languages = response.data.languages
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },



    onSubmit(e) {

      e.preventDefault();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };
        const str= this.block_users;
        const arr =str.split('\n');

      let formData = new FormData();
      formData.append("slug","weekly")
      formData.append("users_phone",JSON.stringify(arr));





      this.$axios
          .post(`${ADMIN_URL}/block-user`,formData,config)
          .then((response) => {
            console.log("Success", response);
            console.log(response.data);
            if(response.data.success)
            {
              this.$swal("Success", response.data.message, "success");
              window.location.href = "/block/user";
            }
            else
            {
              this.$swal("Error",response.data.message, "error");
            }

          })
          .catch((error) => {
            console.log("Error  ... ", error);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css" >

</style>

